import request from '@/utils/request';
export const defaultCohort = {
    id: "00000",
    name: "Pro Bootcamp"
};
export const getCohorts = (params) => request({
    url: '/cohorts',
    method: 'get',
    params
});
export const getCohort = (id, params) => request({
    url: `/cohorts/${id}`,
    method: 'get',
    params
});
//# sourceMappingURL=cohorts.js.map